define([
	"dojo/_base/declare",
	"dojo/dom-class",
	"csi/gallery/Widget",
	"csi/html",
	"csi/locale",
	"dojo/dom-style"
], function(declare,domClass,Gallery,html,locale,style) {
	
	return declare(Gallery, {
		prefClass: null,

		onDrawUserLastPublishedTime: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode) {
			var lastChange = ctx.getNodeAttributeValue("UserLastPublishedTime");
			var lastRollup = ctx.getNodeAttributeValue("LastUpdatePickedUp");
			
			if (lastChange && (!lastRollup || lastChange > lastRollup)) {
				domClass.add(refNode, "changeNotRolledUp");
			} else {
				domClass.add(refNode, "changeRolledUp");
			}
		},

		onDrawProcessingTime: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode) {
			var	millis = ctx.getNodeAttributeValue("EstimateProcessingTime");
			var minutes = Math.floor(millis / 60000);
			var seconds = Math.floor((millis % 60000) / 1000);
			html.setInnerText(refNode, minutes + ":" + (seconds < 10 ? "0" : "") + seconds);
		},
		
		onDrawStatus: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode) {
			var	start = ctx.getNodeAttributeValue("CurrentRollupStartTime");
			html.setInnerText(refNode, locale.resource(start ? "RollupCalculating" : "RollupSleeping"));
		},
		
		_redraw: function() {
			// this a workaround to fix DE16809: 
			// to avoid shrinking of the Rollup status dialog during the refresh, set the min-width in css to the current width
			var c_node = this.contentNode.domNode;
			var width = style.get(c_node,"width");
			c_node.style.minWidth = width+"px";
			this.inherited(arguments);
		}
	});
});